import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DefaultLayoutComponent } from "./containers";
import { P404Component } from "./views/error/404.component";
import { P500Component } from "./views/error/500.component";
import { LoginComponent } from "./views/login/login.component";
import { QuotationPolicyComponent } from "@views/quotation-policy/quotation-policy.component";
import { QuotationRoadTaxComponent } from "@views/quotation-road-tax/quotation-road-tax.component";
import { PaymentComponent } from "@views/payment/payment.component";

export const routes: Routes = [
  {
    path: '',
    component: QuotationPolicyComponent,
    pathMatch: "full",
  },
  {
    path: "roadtax",
    component: QuotationRoadTaxComponent,
    pathMatch: "full",
  },
  {
    path: "payment",
    component: PaymentComponent,
    pathMatch: "full",
  },
  {
    path: "admin",
    component: LoginComponent,
    pathMatch: "full",
  },
  {
    path: "404",
    component: P404Component,
    data: {
      title: "Page 404",
    },
  },
  {
    path: "500",
    component: P500Component,
    data: {
      title: "Page 500",
    },
  },
  {
    path: "login",
    component: LoginComponent,
    data: {
      title: "Login Page",
    },
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: "BMS",
    },
    children: [
     
     
    ],
  },
  { path: "**", component: P404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
